import { Gallery_Navigation_Item_default } from "./chunk-I365FE5F.js";
import { GalleryContext, GalleryNavigationContext } from "./chunk-JMBPVZMW.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Gallery/Gallery.Navigation.MoreButton.tsx
import React, { useContext, useCallback } from "react";
import clsx from "clsx";
var GalleryNavigationMoreButton = _a => {
  var _b = _a,
    {
      onClick,
      className
    } = _b,
    rest = __objRest(_b, ["onClick", "className"]);
  const {
    totalItems
  } = useContext(GalleryContext);
  const {
    maxItems,
    setIsNavExpanded,
    isNavExpandable
  } = useContext(GalleryNavigationContext);
  const itemNumber = maxItems + 1;
  const handleClick = useCallback(event => {
    if (isNavExpandable) {
      setIsNavExpanded(true);
    }
    onClick == null ? void 0 : onClick(event);
  }, [isNavExpandable, onClick, setIsNavExpanded]);
  return /* @__PURE__ */React.createElement(Gallery_Navigation_Item_default, __spreadProps(__spreadValues({}, rest), {
    itemNumber,
    onClick: handleClick,
    className: clsx("pd-gallery-navigation__button--more", className)
  }), "+", totalItems - maxItems);
};
var Gallery_Navigation_MoreButton_default = GalleryNavigationMoreButton;
export { Gallery_Navigation_MoreButton_default };